// Forcing the LOCALSTORAGE driver here (added purely so auth state was easier to inspect/edit
// during manual QA - see git history) raced with other modules (zustand's persist middleware
// in useStore.hook.ts, itself backed by the same shared localforage instance) that can trigger
// localforage's lazy default-driver (IndexedDB) initialization first. localforage silently
// no-ops a config() call made after first use, so this override was unreliable on non-prod -
// confirmed live on dev (2026-08-20): the Google sign-in callback's own
// localforage.setItem/getItem round trip intermittently landed in the wrong backing store,
// signing the user straight back out. Production never ran this branch and was never affected.
// Removed rather than fixed - it was a debugging convenience, not a requirement, and the
// default driver (IndexedDB, same as prod) is enough for a browser's own devtools to inspect.
import { usePersistAutoLink } from '@app/domain/qr-code/hooks/usePersistAutoLink';

/**
 * These side effects happen before navigation resolved.
 * Important case - autoLinkQRID for already authorized users:
 * - sign up and sign in pages are not available for already authorized users
 * - so users redirected before RootModule rendered
 * - auto redirect removes query params so auto link info lost
 * - but this component triggers auto link before auto redirect
 */
export const AppSideEffects: React.FC = () => {
  usePersistAutoLink();
  return null;
};
